import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom'

import Navbar from '../components/navbar_poc'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer';
import SEO from '../components/seo'
import PodcastPlayer3 from '../components/podcast-player3'
import bg from '../assets/images/bg.jpg'
import heroImg from '../assets/images/B2BBookCoverv4.jpg'

import { contactData,footerBlogSocial } from '../data'

import Modal from 'react-bootstrap/Modal';
import emailjs from '@emailjs/browser';
import axios from 'axios'
const cameFromForm = () => {
    // e.g., look for a flag in sessionStorage set after successful POST
    return sessionStorage.getItem("exec_summary_submitted") === "1";
  };
  
export default function PageThankYou() {
    const location = useLocation();
  const firstName =
    location?.state?.firstName ||
    new URLSearchParams(window.location.search).get("name") ||
    "";
    const navigate = useNavigate();
   
    useEffect(() => {
      if (!cameFromForm()) {
        navigate("/bridge"); // fallback
      }
    }, [navigate]);
  // Optional: fire conversion event(s) here once the page loads
  useEffect(() => {
    // LinkedIn (pageview is tracked by Insight Tag automatically;
    // if you use a specific conversion, you can also dispatch a custom event here).
    // window.lintrk && window.lintrk('track', { conversion_id: 1234567 });

    // Google Analytics (example for gtag)
    // window.gtag && window.gtag('event', 'exec_summary_download', { method: 'linkedin_ad_or_site' });
  }, []);

  return (
    <>
              <Navbar />
            <SEO
                title="Download - Thank you!"
                description="Thank you for downloading the executive summary"
                url="https://www.pioneeroneglobal.com/podcast"
                image="https://www.pioneeroneglobal.com/images/option2.png"
            />
                     <section className="bg-half-170 bg-light d-table w-100">
                     <div className="container">
  <div className="row align-items-center mt-5">
    <div className="col-lg-6 col-md-5">
      <div className="me-lg-5">
      <img
  src={heroImg}
  className="img-fluid rounded"
  alt=""
  style={{ maxHeight: "500px", objectFit: "cover" }}
/>
        {/* <img src={heroImg} className="img-fluid rounded" alt="" /> */}
      </div>
    </div>

    <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
      <div className="title-heading mt-4">
        <h1 className="heading mb-3">Thank you{firstName ? `, ${firstName}` : ""}!</h1>
        <p className="para-desc text-muted">
        We’ve sent the download link to your email. It should arrive shortly. The pdf link would be valid for 20 hours. In case you are unable to download it by then, please fill out the form again.
        </p>
      </div>


    </div>
  </div>
</div>        
  </section>
    <section className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">

          <hr className="my-4" />

          <h5 className="mt-4">While you wait</h5>
                <div className="section-title mb-4 pb-2">
                                           <PodcastPlayer3 />
             </div>
          <ul className="list-unstyled mb-4">
            
            <li className="mb-2">
              🗓️ <a href="https://calendly.com/pioneeroneglobal/30min" target="_blank" rel="noreferrer">
                Book a free 30-minute India Readiness Assessment
              </a>
            </li>
          </ul>

          <p className="text-muted">
            Didn’t get the email after a few minutes? Check your promotions/spam folder or contact{" "}
            <a href="mailto:contact@pioneeroneglobal.com">contact@pioneeroneglobal.com</a>.
          </p>
        </div>
      </div>
    </section>
     <Footer />
    </>
  );
 
}
